module.exports = __webpack_public_path__ + "static/logo-14aabcd21ae07650b0c8ae1c8ff2e8f2.svg";